<span *ngFor="let lang of AvailableLanguages">
    <a *ngIf="!Selected(lang);" (click)="SetLanguage(lang);">{{ lang.name }} <img [src]="lang.icon"></a>
</span>